import { CustomerAttribute, CustomerAttributeGroup } from '@common/customerAttributes/types.js';

//
// Detects changes between two sets of customer attributes
// consentB is expected to be the updated customer attribute list
//
export const customerAttributesChanges = (
  cattrsA: CustomerAttribute[],
  cattrsB: CustomerAttribute[],
) => {
  const changes = {
    granted: 0,
    revoked: 0,
  };

  cattrsA.forEach((cattrA) => {
    const cattrB = cattrsB.find((cB) => cB.id === cattrA.id);
    if (cattrB) {
      ['standard', 'extra'].forEach((itemGroup) => {
        if (!cattrA[itemGroup] || !cattrB[itemGroup]) {
          return;
        }

        const cattrAItems = (cattrA[itemGroup] as CustomerAttributeGroup).items;
        const cattrBItems = (cattrB[itemGroup] as CustomerAttributeGroup).items;

        cattrAItems.forEach((cattrAItem) => {
          const cattrBItem = cattrBItems.find((cB) => cB.id === cattrAItem.id);
          if (cattrBItem) {
            if (cattrAItem.granted === cattrBItem.granted) return;
            if (cattrBItem.granted === true) {
              changes.granted += 1;
            } else {
              changes.revoked += 1;
            }
          }
        });
      });
    }
  });

  return changes;
};
